export interface ModeCard {
  id?: string;
  path: string;
  label: string;
  emoji: string;
  description: string;
  /** Border + accent color in idle state. */
  color: string;
  /** 'play' = the actual game / social hub; 'sandbox' = test arenas + dev tools. */
  group: 'play' | 'sandbox';
  /** Local dev/QA utility; omitted from deployed production surfaces. */
  devOnly?: boolean;
}

export const MODES: ModeCard[] = [
  {
    path: '/adventure',
    label: 'Adventure',
    emoji: '🗺️',
    description: 'Explore the Hollow Coil, from warm village paths to the mysteries beyond.',
    color: '#2ecc71',
    group: 'play',
  },
  {
    path: '/intro',
    label: 'New Adventure',
    emoji: '🌅',
    description: 'Create your hero and begin in the candlelit Waking Vault. A new journey starts here.',
    color: '#f6c45e',
    group: 'play',
  },
  {
    path: '/resume',
    label: 'Resume',
    emoji: '💾',
    description: 'Choose a saved hero and continue their journey, with their gear, quests, and progress.',
    color: '#5dade2',
    group: 'play',
  },
  {
    path: '/lobby',
    label: 'Lobby',
    emoji: '🏠',
    description: 'Meet other players, chat, and spend time together.',
    color: '#3498db',
    group: 'play',
  },
  {
    path: '/gmrace',
    label: 'GM Race',
    emoji: '🏁',
    description: 'Gather at the starting line for an event race. The host begins the run.',
    color: '#ff6b6b',
    group: 'play',
  },
  {
    path: '/biomes',
    label: 'Biome Nexus',
    emoji: '🌀',
    description: 'Discover different landscapes, from frozen lakes to flooded ruins.',
    color: '#a55eea',
    group: 'play',
  },
  {
    path: '/sunken',
    label: 'Sunken Whales',
    emoji: '🐋',
    description: 'A quiet visit to the Drowned Cathedral, beneath the drifting giants.',
    color: '#1f8a8a',
    group: 'play',
  },
  {
    id: 'hollow-keeper-qa',
    path: '/qa/hollow-keeper',
    label: 'Hollow Keeper QA',
    emoji: '🕯️',
    description: 'Local memory-mode boss launch. Level 12, Keeper quest at 0/1, staged on the Undercroft dais within attack range.',
    color: '#79c99e',
    group: 'sandbox',
    devOnly: true,
  },
  {
    id: 'mobile-qa',
    path: '/mobile',
    label: 'Mobile Touch QA',
    emoji: '📱',
    description: 'Instant mobile test sandbox with dual touch sticks, Dev action bar, and noclip on First Field.',
    color: '#38bdf8',
    group: 'sandbox',
    devOnly: true,
  },
  {
    path: '/brawl',
    label: 'Brawl',
    emoji: '⚔️',
    description: 'A fast, chaotic battle with quick respawns.',
    color: '#e74c3c',
    group: 'sandbox',
  },
  {
    path: '/arena',
    label: 'Arena',
    emoji: '🏟️',
    description: 'Battle across stacked platforms and challenge your positioning.',
    color: '#e67e22',
    group: 'sandbox',
  },
  {
    path: '/pve',
    label: 'PvE',
    emoji: '🐷',
    description: 'Fight creatures, gather loot, and practice without player combat.',
    color: '#27ae60',
    group: 'sandbox',
  },
  {
    path: '/abilitygrounds',
    label: 'Ability Grounds',
    emoji: '🎯',
    description: 'Try abilities against practice targets and explore their effects.',
    color: '#f39c12',
    group: 'sandbox',
  },
  {
    path: '/debug',
    label: 'Debug',
    emoji: '🛠️',
    description: 'Inspect the game with its diagnostic overlays.',
    color: '#9b59b6',
    group: 'sandbox',
  },
  {
    path: '/combatlab',
    label: 'Combat Lab',
    emoji: '📐',
    description: 'Study attack reach and effects in a measured practice arena.',
    color: '#7ad0ff',
    group: 'sandbox',
  },
  {
    path: '/editor',
    label: 'Map Editor',
    emoji: '✏️',
    description: 'Build levels, place scenery, and connect portals.',
    color: '#1abc9c',
    group: 'sandbox',
  },
  {
    path: '/screensaver',
    label: 'Screensaver',
    emoji: '🎬',
    description: 'A peaceful camera tour through the world’s landscapes.',
    color: '#9b59b6',
    group: 'sandbox',
  },
];
